import { FC } from 'react'

import { Network } from '@tribeplatform/gql-client/types'

import { useCurrentPage } from '../hooks/useCurrentPage'
import { Layout } from './Layout'
import { PageMeta } from './PageMeta'
import { Space } from './Space/Space'

export const SpaceRoutes: FC<{
  network: Network
}> = ({ network }) => {
  const { data: page } = useCurrentPage()

  return (
    <Layout
      layout={page?.space?.layout}
      navigationSlates={network.navigationSlates}
    >
      <PageMeta page={page} />
      <Space network={network} space={page?.space} />
    </Layout>
  )
}
